import React from "react";
import { CreatorIcon, SprintIcon, TagIcon } from "app/components/Icons";
import CalendarIcon from "app/components/Icons/CalendarIcon";
import ComponentIcon from "app/components/Icons/ComponentIcon";
import EnvironmentIcon from "app/components/Icons/EnvironmentIcon";
import FlagIcon from "app/components/Icons/FlagIcon";
import ReleaseIcon from "app/components/Icons/ReleaseIcon";
import SeverityIcon from "app/components/Icons/SeverityIcon";
import StatusIcon from "app/components/Icons/StatusIcon";
import TicketsIcon from "app/components/Icons/TicketsIcon";
import UserIcon from "app/components/Icons/UserIcon";
import TargetReleaseIcon from "app/components/Icons/TargetReleaseIcon";
import { GroupByTypeEnum } from "../../types";

export const SEARCHABLE_FILTER_IDS = new Set<string>([
  GroupByTypeEnum.TAGS,
  GroupByTypeEnum.TARGET_RELEASE,
  GroupByTypeEnum.SPRINT,
  GroupByTypeEnum.ENVIRONMENT,
  GroupByTypeEnum.COMPONENT,
  GroupByTypeEnum.ASSIGNEE,
  GroupByTypeEnum.CREATOR,
]);

export const FiltersNew = [
  {
    id: GroupByTypeEnum.TICKET_TYPE,
    name: "Ticket Type",
    icon: React.createElement(TicketsIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.STATUS,
    name: "Status",
    icon: React.createElement(StatusIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.TAGS,
    name: "Tags",
    icon: React.createElement(TagIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.DUE_DATE,
    name: "Due Date",
    icon: React.createElement(CalendarIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.PRIORITY,
    name: "Priority",
    icon: React.createElement(FlagIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.RELEASE,
    name: "Release",
    icon: React.createElement(ReleaseIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.TARGET_RELEASE,
    name: "Target release",
    icon: React.createElement(TargetReleaseIcon, {
      color: "#79808A",
      size: 20,
    }),
  },
  {
    id: GroupByTypeEnum.SPRINT,
    name: "Sprint",
    icon: React.createElement(SprintIcon, { color: "#79808A", size: 20 })
  },
  {
    id: GroupByTypeEnum.ENVIRONMENT,
    name: "Environment",
    icon: React.createElement(EnvironmentIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.SEVERITY,
    name: "Severity",
    icon: React.createElement(SeverityIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.COMPONENT,
    name: "Component",
    icon: React.createElement(ComponentIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.ASSIGNEE,
    name: "Assignee",
    icon: React.createElement(UserIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.CREATOR,
    name: "Creator",
    icon: React.createElement(CreatorIcon, { color: "#79808A", size: 20 }),
  },
  {
    id: GroupByTypeEnum.CREATED_DATE,
    name: "Creation date",
    icon: React.createElement(CalendarIcon, { color: "#79808A", size: 20 }),
  },
];
